import { Component, ViewChild, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpService } from '../../services/http.service';
import { AuthenService } from '../../services/authen.service';

class CustomerMasterRow {
    label1: string;
    obj1: any;
    label2: string;
    obj2: any;
}

@Component({
    selector: 'customer-master-prop',
    templateUrl: './customer-master-prop.html',
})
export class CustomerMasterPropComponent implements OnInit {
    id: number = 0;
    subs: any = null;
    data: CustomerMasterRow[] = [
        { label1: 'Custcode', obj1: null, label2: 'Custname', obj2: null },
        { label1: 'Areacode', obj1: null, label2: 'Areaname', obj2: null },
        { label1: 'Provincecode', obj1: null, label2: 'Provincename', obj2: null },                
        { label1: 'Notes', obj1: null, label2: 'Active', obj2: null }        
    ]

    constructor(private http: HttpService, private auth: AuthenService, private route: ActivatedRoute) {
        this.subs = route.params.subscribe(params => {
            this.id = params['id'];
        })
    }

    ngOnDestroy() {
        this.subs.unsubscribe();
    }

    ngOnInit() {
        if (this.id > 0)
            this.load(this.id);
    }

    load(id: number) {
        this.http.get(`api/CustomerMaster/Get/${id}`, res => {
            let p = res.Result;
            if (p != null) {
                this.data[0].obj1 = p.Custcode;
                this.data[0].obj2 = p.Custname;
                this.data[1].obj1 = p.Areacode;
                this.data[1].obj2 = p.Areaname;
                this.data[2].obj1 = p.Provincecode;
                this.data[2].obj2 = p.Provincename;
                this.data[3].obj1 = p.Notes;
                this.data[3].obj2 = p.Active;                
            }
        });
    }
}
